import styled from "styled-components";
import { fonts } from "styles";

export const Container = styled.section`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: black;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 48px;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 40px;
  line-height: 40px;
  margin-bottom: 24px;
  text-align: center;
  color: white;
  text-transform: uppercase;
`;

export const Text = styled.article`
  text-align: center;
  color: white;
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 20px;
`;
